/**
 * @vuepress
 * ---
 * title: file
 * ---
 */
import Transformer from '@/transformers/transformer'

/**
 * @class cancelTransformer
 * Cancel payload transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class cancelTransformer extends Transformer {
  /**
   * Transform file to send
   *
   * @param file to send file
   *
   * @returns {Object} The transformed file
   */

  static send(file) {
    const formData = new FormData()
    formData.append('cfdi', file.id)
    formData.append('cancellation_request_file', file.file)
    return formData
  }

}

export default cancelTransformer


// WEBPACK FOOTER //
// ./src/transformers/taxReceipt/requestCancellation.js